import { getQueryWithParams, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { TOTAL_APPOINTMENTS_COUNT, LIST_PATIENT_RECORDS, GET_BILLINGS, LIST_DOCTOR_REVIEWS, } from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";
import dayjs from "dayjs";

import 'dayjs/locale/en'; // Import the English locale (or any other you need)
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.locale('en'); // Set the locale globally

export async function listDoctorReviews() {
  try {
    let response = await getQueryWithParams(LIST_DOCTOR_REVIEWS);
    if (response?.data?.listDoctorReviews?.data) {
      return response.data.listDoctorReviews.data;
    } else {
      throw new Error(response);
    }
  } catch (error) {
    snackbar({
      message: "Error while getting DoctorReviews.",
      color: "danger",
    });
    console.error("ERROR at list appointments", error);
    return [];
  }
}
export async function getTotalNumberOfAppointments() {
  try {
    let response = await getQueryWithParams(
      TOTAL_APPOINTMENTS_COUNT("status=Completed")
    );
    if (typeof response == "undefined") {
      throw new Error(response);
    } else {
      if (response?.data?.listAppointmentsDoctor?.totalCount >= 0) {
        return response.data.listAppointmentsDoctor.totalCount;
      } else {
        throw new Error(response);
      }
    }
  } catch (error) {
    snackbar({
      message: "Error while getting Total Number of Appointments.",
      color: "danger",
    });
    console.error("ERROR at list appointments", error);
    return null;
  }
}

export async function getAppointmentsStartDate() {
  try {
    let response = await getQueryWithParams(
      TOTAL_APPOINTMENTS_COUNT("status=Completed")
    );
    if (typeof response == "undefined") {
      throw new Error(response);
    } else {
      if (response?.data?.listAppointmentsDoctor?.data) {
        return response.data.listAppointmentsDoctor.data;
      } else {
        throw new Error(response);
      }
    }
  } catch (error) {
    snackbar({
      message: "Error while getting Appointments Chart.",
      color: "danger",
    });
    console.error("ERROR at list appointments", error);
    return [];
  }
}

export async function listAppointmentsYearByYear() {
  try {
    const appointments = await getAppointmentsStartDate();
    const monthlyCounts = {};

    appointments.forEach(appointment => {
      const date = dayjs(appointment.start);
      const monthName = date.format('MMMM');
      const year = date.format('YYYY');
      const monthYear = `${monthName} ${year}`;

      monthlyCounts[monthYear] = (monthlyCounts[monthYear] || 0) + 1;
    });

    const formattedCounts = Object.entries(monthlyCounts).map(([monthYear, totalCount]) => {
      const [month, year] = monthYear.split(' ');
      return { month, year, totalCount, monthIndex: dayjs().month(month).format('M') };
    });

    // Sort by year and month chronologically
    return formattedCounts.sort((a, b) => {
      if (a.year !== b.year) {
        return a.year - b.year;
      }
      return a.monthIndex - b.monthIndex;
    });
  } catch (error) {
    return [];
  }
}

export async function getPatientsCreatedAt() {
  try {
    let response = await getQueryWithParams(LIST_PATIENT_RECORDS(2147483647));
    if (typeof response == "undefined") {
      throw new Error(response);
    } else {
      if (response?.data?.listDoctorPatients?.data) {
        return response.data.listDoctorPatients.data;
      } else {
        throw new Error(response);
      }
    }
  } catch (error) {
    snackbar({
      message: "Error while getting Patients Chart.",
      color: "danger",
    });
    console.error("ERROR at list appointments", error);
    return [];
  }
}

export async function listPatientsYearByYear() {
  try {
    const data = await getPatientsCreatedAt();
    console.log("Patients year by year data", data);
    let patientsYearByYear = {}; // Use object literal

    data.forEach((patient) => {
      let currPatientDate = dayjs(patient.createdAt);
      let currYear = currPatientDate.year(); // Get the year

      if (patientsYearByYear[currYear]) {
        patientsYearByYear[currYear]++;
      } else {
        patientsYearByYear[currYear] = 1;
      }
    });

    let arr = Object.keys(patientsYearByYear).map((key) => ({
      year: String(key),
      value: patientsYearByYear[key],
    }));

    return arr;
  } catch (err) {
    return [];
  }
}

export async function getDoctorBillings() {
  try {
    const data = [];
    const doctorId = sessionStorage.getItem("role-id");
    //this week res
    var curr = new Date(); // get current date
    var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    var firstday = new Date(curr.setDate(first));
    var lastday = new Date(curr.setDate(last));

    firstday.setHours(0, 0, 0, 0);
    lastday.setHours(0, 0, 0, 0);

    let thisWeek = await getQueryWithParams(GET_BILLINGS, {
      doctorId,
      start: firstday.toISOString(),
      end: lastday.toISOString(),
    });

    if (thisWeek?.data?.getTotalBillingsOfDoctor?.data?.totalBillings >= 0) {
      data.push({
        title: "This Week",
        value: thisWeek.data.getTotalBillingsOfDoctor.data.totalBillings / 100,
      });
    } else {
      throw new Error("error");
    }

    //last week
    var lastWeekStart = new Date(
      firstday.getFullYear(),
      firstday.getMonth(),
      firstday.getDate() - 7
    );
    var lastWeekEnd = new Date(
      lastday.getFullYear(),
      lastday.getMonth(),
      lastday.getDate() - 7
    );
    let lastWeek = await getQueryWithParams(GET_BILLINGS, {
      doctorId,
      start: lastWeekStart.toISOString(),
      end: lastWeekEnd.toISOString(),
    });

    if (lastWeek?.data?.getTotalBillingsOfDoctor?.data?.totalBillings >= 0) {
      data.push({
        title: "Last Week",
        value: lastWeek.data.getTotalBillingsOfDoctor.data.totalBillings / 100,
      });
    } else {
      throw new Error("error");
    }

    //this month

    var y = curr.getFullYear(),
      m = curr.getMonth();
    firstday = new Date(y, m, 1);
    lastday = new Date(y, m + 1, 0);
    let thisMonth = await getQueryWithParams(GET_BILLINGS, {
      doctorId,
      start: firstday.toISOString(),
      end: lastday.toISOString(),
    });
    if (thisMonth?.data?.getTotalBillingsOfDoctor?.data?.totalBillings >= 0) {
      data.push({
        title: "This Month",
        value: thisMonth.data.getTotalBillingsOfDoctor.data.totalBillings / 100,
      });
    } else {
      throw new Error("error");
    }
    return data;
  } catch (error) {
    snackbar({
      message: "Error while getting Patients Chart.",
      color: "danger",
    });
    console.error("ERROR at list appointments", error);
    return [];
  }
}

// return number of patients created in last 12 months
export const countPatientsByMonthYear = (patients) => {
  const monthlyCounts = {};

  patients.forEach(patient => {
    const date = dayjs(patient.createdAt);
    const monthName = date.format('MMMM');
    const year = date.format('YYYY');
    const monthYear = `${monthName} ${year}`;

    monthlyCounts[monthYear] = (monthlyCounts[monthYear] || 0) + 1;
  });

  const formattedCounts = Object.entries(monthlyCounts).map(([monthYear, totalCount]) => {
    const [month, year] = monthYear.split(' ');
    return { month, year, totalCount, monthIndex: dayjs().month(month).format('M') };
  });

  // Sort by year and month chronologically
  return formattedCounts.sort((a, b) => {
    if (a.year !== b.year) {
      return a.year - b.year;
    }
    return a.monthIndex - b.monthIndex;
  });
};